<div class="footer">
  @if(language == 'Ar'){
  <div class="service service--ar">{{ footer1() }}</div>
  <div class="service2 service2--ar">
    {{ footer2() }}
  </div>
  } @else {
  <div class="service">{{ footer1() }}</div>
  <div class="service2">
    {{ footer2() }}
  </div>
  }

  <div class="slogan">Arada Home Away From Home</div>

  <div class="icons">
    <div class="insta" (click)="goToInsta()">
      <svg class="icon">
        <use xlink:href="images/sprites9.svg#icon-instagram"></use>
      </svg>
    </div>

    <div class="phone" (click)="onCall()">
      <svg class="icon">
        <use xlink:href="images/sprites9.svg#icon-phone"></use>
      </svg>
    </div>
    <div class="website" (click)="onWeb()">
      <svg class="icon">
        <use xlink:href="images/sprites9.svg#icon-world"></use>
      </svg>
    </div>
  </div>
</div>
